import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ToastService } from 'ng-uikit-pro-standard';

import * as _ from 'lodash';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { DatesService } from 'src/app/shared/services/dates.service';
import { RecorridoService } from 'src/app/services/recorrido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';

@Component({
  selector: 'app-mercaderia-devuelta',
  templateUrl: './mercaderia-devuelta.component.html',
  styleUrls: ['./mercaderia-devuelta.component.scss'],
  providers: [SecurityService],
})
export class MercaderiaDevueltaComponent implements OnInit {
  // Form
  formHeader: FormGroup;

  // Data & tmp
  private currentPayload: any = null;
  private rutEmpresa: number;
  private sucursalCodigo: number;
  paginationContext: PaginationContext = new PaginationContext();

  // Utils
  private log: any;
  camion_patente: any;
  choferNombre: string;

  sinRecorrido: string = 'Sin Recorrido';
  divStyle: string;
  loading: boolean;
  processing: boolean = false;

  listaRecorridosDev: any;
  groupArr: any;
  totalCajas: number;
  totalUnidades: number;
  ChoferxPatente: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private datesService: DatesService,
    private recorridoService: RecorridoService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('MERCADERIA DEVUELTA');
  }

  optionsRecorrido: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.paginationContext.RecordsByPage = 10;

    this.createForm();
    this.loadRecorridos();

    this.formChangesSubscriptions();
  }

  formChangesSubscriptions() {
    this.formHeader.get('listaRecorridos').valueChanges.subscribe((recorrido: Number) => {
      //** Obtener codigo del nro recorrido seleccionado para obtener chofer y patente*/
      this.ChoferxPatente = this.optionsRecorrido.filter((p) => p.value === recorrido)[0].codigo;

      this.loadChoferPatente(this.ChoferxPatente);
    });

    this.formHeader.get('fechaProceso').valueChanges.subscribe((fdesde) => {
      this.loadRecorridos();
    });
  }

  loadChoferPatente(code) {
    const inputParams = {
      entidad: {
        exacto: {
          codigo: code,
          camion_patente: '',
          chofer_rut: -1,
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
        },
      },
    };

    this.recorridoService.ObtenerChoferyPatenteRecorrido(inputParams, ({ respuesta }) => {
      const ok = respuesta.registros.length > 0;
      // *  Si los registros se encuentran en el recorrido - obtener parametro y mostrarlo en pantalla */
      if (ok) {
        const { registros } = respuesta;
        this.camion_patente = registros[0].camion_patente;
        this.choferNombre = registros[0].nombreChofer;
      }
    });
  }

  //** Cargar los datos de recorridos en base a la fechaProceso
  private loadRecorridos() {
    const inputParams = {
      entidad: {
        exacto: {
          codigo: -1,
          camion_patente: '',
          chofer_rut: -1,
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          fecha: this.formHeader.get('fechaProceso').value,
        },
      },
    };
    this.recorridoService.ObtenerListadoRecorridosDevoluciones(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;

      if (registros.length == 0) {
        this.optionsRecorrido = [{ value: 0, label: 'SIN RECORRIDO' }];
        this.processing = false;

        this.camion_patente = '';
        this.choferNombre = '';
        this.divStyle = 'none';
      } else {
        this.optionsRecorrido = registros.map((recorrido) => ({
          value: recorrido.codigo,
          label: `${recorrido.codigo} - ${recorrido.nombreChofer}`,
          camionPatente: recorrido.camion_patente,
          choferNombre: recorrido.nombreChofer,
          ...recorrido,
        }));
        this.divStyle = 'block';
      }

      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('listaRecorridos'), this.optionsRecorrido);
    });
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();
    this.formHeader = this.fb.group({
      fechaProceso: [currentDate, [Validators.required]],
      listaRecorridos: [[]],
      listaTipoDoc: [[]],
      documento: [true],
      copia_cedible: [true],
      enviar_pdf: [true],
      enviar_xml: [true],
      orden_envio: [0],
    });
  }

  //** Filtro de mercaderia de vuelta al seleccionar los datos */
  buscar(pageNumber: number) {
    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.paginationContext.CurrentPage = pageNumber;

    const { listaRecorridos } = this.formHeader.value;

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      recorridos: listaRecorridos,
      paginaActual: this.paginationContext.CurrentPage,
      CantidadRegistrosPagina: 10,
    };

    this.currentPayload = _.cloneDeep(inputParams);

    this.log('inputParams', JSON.stringify(inputParams));

    this.loading = true;
    this.processing = true;
    this.listaRecorridosDev = null;

    this.recorridoService.ObtenerReporteDevoluciones(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      const { registros } = respuesta;

      if (registros.length > 0) {
        this.listaRecorridosDev = registros;

        this.groupArr = registros.reduce((r, { codigoFamilia }) => {
          if (!r.some((o) => o.codigoFamilia == codigoFamilia)) {
            r.push({ codigoFamilia, groupItem: registros.filter((v) => v.codigoFamilia == codigoFamilia) });
          }

          return r;
        }, []);

        //* Total ¨*/

        let sumBultos = 0;
        let sumUnidades = 0;
        this.groupArr.forEach((element) => {
          element.groupItem.forEach((sumas) => {
            sumBultos += sumas.bultos;
            sumUnidades += sumas.unidades;
          });
          this.totalCajas = sumBultos;
          this.totalUnidades = sumUnidades;
        });

        this.paginationContext.RecordsCount = this.listaRecorridosDev.length; //totalRegistros
        this.paginationContext.PagesCount = Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage); //totalPaginas
        this.paginationContext.CurrentPage = 1;

        // this.showPage(this.paginationContext.CurrentPage)
        this.loading = false;
      } else {
        this.loading = false;
        this.listaRecorridosDev = [];
        this.groupArr = [];
      }
    });
  }

  exportarExcel() {
    const inputParams = _.cloneDeep(this.currentPayload);
    delete inputParams.paginaActual;
    delete inputParams.cantidadRegistrosPorPagina;

    this.log('XLS', JSON.stringify(inputParams));

    if (!this.ChoferxPatente) {
      this.toastService.warning('No se encuentra nro recorrido');
      return;
    }

    this.recorridoService.ObtenerDevolucionesxRecorridoExcel(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        this.loading = false;
        return;
      }

      this.log('excel respuesta', respuesta);
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta);
    });
  }

  downloadExcelPdf(type: 'XLS' | 'PDF'): void {
    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      recorridos: this.ChoferxPatente, // * Obtener codigo del recorrido
    };

    if (!this.ChoferxPatente) {
      this.toastService.warning('No se encuentra nro recorrido');
      return;
    }

    this.recorridoService.ObtenerDevolucionesxRecorridoPDF(inputParams, ({ mensajes, respuesta }) => {
      console.log('🚀 ~ file: mercaderia-devuelta.component.ts ~ line 442 ~ MercaderiaDevueltaComponent ~ this.recorridoService.reportePDFMercaderiaDevuelta ~ respuesta', respuesta);
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      if (respuesta) this.fileDownloadService.VerifyAndDownload(respuesta);
    });
  }

  // showPage(pageNumber: number) {
  //   this.paginationContext.CurrentPage = pageNumber
  //   const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
  //   this.listaRecorridosDev = _.slice(this.listaRecorridosDev, start, start + this.paginationContext.RecordsByPage)
  // }

  // onPageChange(context: PaginationContext) {
  //   this.showPage(context.RequestedPage)
  // }
}
